<div class="panel-div ">

  <form class="search-form" [formGroup]="form" *ngIf="showSearchForm">

    <div class="row mt-2 g-2">
      <div class="col-md-4">
        <div class="field">
          <label for="" class="form-label">Name</label>
          <input type="text" class="form-control" formControlName="name" [maxlength]="50" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="field">
          <label for="" class="form-label">Description</label>
          <input type="text" class="form-control" formControlName="description" [maxlength]="100" />
        </div>
      </div>

      <div class="col-md-4">
        <div class="field">
          <label for="" class="form-label">Status</label>
          <select class="form-control small-option-font" formControlName="status">
            <option value="">-- Select--</option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
            <option value="DELETED">Deleted</option>
        </select>
        </div>
      </div>
    </div>

    <span class="material-symbols-outlined text-danger" style="position: absolute; top: 5px; right: 10px;" role="button"
      (click)="toggleShowSearch()">close</span>
    <button class="custom-btn-primary search-button ms-auto" (click)="search(); toggleShowSearch()">Search</button>
  </form>

  <div class="table-wrapper border-radius-bottom">
    <table class="role-table amc-table">
      <thead class="amc-table-heading">
        <tr>
          <th class="ps-4">Name</th>
          <th>Description</th>
          <th class="text-center">Status</th>
          <th class="text-center"  *ngIf="hasAccess(['GENERAL_PERMISSION'])">Action</th>
        </tr>
      </thead>

      <tbody>
        @if(isLoading || isSearching){
          <tr class="border-0 tr-table-loader">
            <td [colSpan]="7" class="td-table-loader">
              <app-bounce-loader></app-bounce-loader>
            </td>
          </tr>
        } @else {
        @if(!searchedPrivilegeNotFound){
        <tr *ngFor="let privilege of privileges; let i = index">
          <td data-label="Name">{{ privilege?.permission | uppercase }}</td>
          <td data-label="Description"><p class="text-overflow">{{ privilege?.description }}</p></td>
          <td data-label="Status" class="fw-semibold text-center" >
            <span class="warning-label" [ngClass]="'status-text-' + privilege?.status | lowercase">{{ privilege?.status }}</span>
          </td>
          <td data-label="Action"  *ngIf="hasAccess(['GENERAL_PERMISSION'])">
            <div class="amc-table-action-wrapper">
              <span class="material-symbols-outlined action-icon" data-bs-toggle="dropdown">
                more_horiz
              </span>
              <div class="dropdown-menu amc-table-action-select">
                <div class="dropdown-wrapper">
                  <div class="action-btn disabled" *ngIf="privilege?.status == 'DELETED'" role="button">
                    NO ACTION
                  </div>
                  <div class="action-btn" *ngIf="privilege?.status == 'INACTIVE'" role="button"
                    (click)="openActivateConfirmModal(privilege?.privilegeId, privilege?.permission); $event.stopPropagation()">
                    Activate
                  </div>
                  <div class="action-btn" *ngIf="privilege?.status == 'ACTIVE'" role="button"
                    (click)="openDeactivateConfirmModal(privilege?.privilegeId, privilege?.permission); $event.stopPropagation()">
                    Deactivate
                  </div>
                  <div class="action-btn" *ngIf="privilege?.status == 'ACTIVE'" role="button"
                    (click)="openDeleteConfirmModal(privilege?.privilegeId, privilege?.permission); $event.stopPropagation()">
                    Delete
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        } @else{
        <tr class="tr-empty-placeholder">
          <td colspan="5" class="text-center">No results found</td>
        </tr>
        }
        }
      </tbody>
    </table>


  </div>




</div>

<div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">

  <div class="d-flex align-items-center me-4">
    <div>Rows per page: </div>
    <div class="mx-2">
      <select class="form-control px-6 text-center" style="width: auto; min-width: 40px;" [(ngModel)]="selectedLimit"
        (change)="updateLimit()">

        <option [value]=5>5</option>
        <option [value]=10>10</option>
        <option [value]=20>20</option>
        <option [value]=30>30</option>
        <option [value]=40>40</option>
        <option [value]=50>50</option>

      </select>
    </div>
  </div>


  <div class="pagination-container">
    <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage" (pageChange)="callDb($event)" [maxSize]="5"
      [pageSize]="pageSize" [collectionSize]="count" [boundaryLinks]="true" [directionLinks]="true" [rotate]="true"
      class="pagination justify-content-center my-3">
    </ngb-pagination>
  </div>
</div>
